<template>
  <div class="order-header">
    <div>
      {{ $t("order_datetime") }}：
      <span class="value">{{ $d(order.order_date, 'date') }}</span>
    </div>
    <div class="right">{{ $t("order") }}：{{ order.id }}</div>
    <div>
      支払い方法：
      <span class="value">銀行振込</span>
    </div>
    <div class="right">
      <span class="number" />
      {{ $t("order_total_amount_plain") }}：
      <span class="number">{{ $n(totalPrice) }}</span>円
    </div>

    <div class="mt-2">
      {{ $t("delivery_address") }}：
      <strong>{{ locationName }}</strong>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      default: null
    },
    totalPrice: {
      type: Number,
      default: 0
    }
  },
  computed: {
    locationName() {
      return this.order.location && this.order.location.name;
    }
  }
};
</script>

<style lang="scss" scoped>
.order-header {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
  grid-template-rows: max-content max-content;
  align-items: baseline;
  padding: 15px 20px;
  border: #ccc 1px solid;
  border-bottom: none;
  background-color: #eee;

  font-size: 14px;
  color: #111;
}

.value {
  font-size: 16px;
  font-weight: bold;
}

.number {
  font-size: 24px;
  font-weight: bold;
}

.right {
  justify-self: end;
}
</style>
